import { COLOR } from 'admin/constants/styles';
import React, { ElementRef, forwardRef } from 'react';
import styled, { CSSProperties, StyledComponentPropsWithRef } from 'styled-components';
import { InputErrors } from './WithErrors';

type Props = {
  value?: string;
  innerRef?: React.Ref<HTMLTextAreaElement>;
  errors?: string[];
} & React.TextareaHTMLAttributes<HTMLTextAreaElement> &
  Omit<React.ComponentProps<typeof InputErrors>, 'children'>;

const TextAreaInput = styled.textarea<{
  margin?: CSSProperties['margin'];
  width?: CSSProperties['width'];
}>`
  display: block;
  margin: ${(props) => (props.margin ? props.margin : '0 0 0 0')};
  padding: 4px 6px;
  border: 1px solid ${COLOR.lightGray};
  width: ${(props) => (props.width ? props.width : '100%')};
  background: ${(props) => (props.disabled ? '#eee' : 'none')};
  font-size: 1rem;
  text-align: left !important;
  border-radius: 3px;
`;

const TextArea = forwardRef<
  ElementRef<'textarea'>,
  Props & StyledComponentPropsWithRef<typeof TextAreaInput>
>(({ value, innerRef, errors, fullWidth, ...rest }, ref) => {
  return (
    <InputErrors errors={errors} fullWidth={fullWidth}>
      <TextAreaInput ref={innerRef || ref} value={value} {...rest} />
    </InputErrors>
  );
});

export default styled(TextArea)<{ fullWidth?: boolean }>`
  ${({ fullWidth }) => fullWidth && 'width: 100%;'}
`;
